import { Link } from "react-router-dom";
import { statusObject } from "../../utils/allProductStatus";
import { cashnator } from "../../utils/functions";
import { getGradingTypeLabel, getPreLacreFormatLabel, normalizeGradingType } from "../../utils/gradingTypes";
import { DELIVERY_LABELS } from "../productsColumns";
import SimpleTable from "../../table/SimpleTable";

const YES_NO = { true: "Sim", false: "Não" };

const PARTNER_PRODUCT_COLUMNS = [
    { key: "user.name", header: "Nome", width: 180, filter: "list" },
    { key: "gradingType", header: "Tipo", width: 120, filter: "list", accessor: (row) => getGradingTypeLabel(row.gradingType) },
    { key: "autographEvaluation", header: "Autógrafo", width: 110, filter: "list", accessor: (row) => Boolean(row.autographEvaluation), labels: YES_NO },
    {
        key: "preLacreFormat", header: "Pré lacre", width: 150, filter: "list",
        accessor: (row) => (normalizeGradingType(row.gradingType) === "pre" && row.preLacreFormat ? getPreLacreFormatLabel(row.preLacreFormat) : "-"),
    },
    { key: "numberOfCards", header: "Nº de itens", width: 100, filter: "list" },
    { key: "delivery", header: "Entrega", width: 110, filter: "list", labels: DELIVERY_LABELS },
    { key: "finalPrice", header: "Valor final", width: 110, format: (value) => cashnator(value) },
    { key: "createdAt", header: "Criado", width: 110, type: "date", filter: "date" },
    { key: "receivedAt", header: "Recebido", width: 110, type: "date", filter: "date" },
    { key: "paidAt", header: "Pago", width: 110, type: "date", filter: "date" },
    { key: "calculatedDeadline", header: "Prazo", width: 110, type: "date", filter: "date" },
    { key: "status", header: "Status", width: 180, filter: "list", labels: statusObject },
    {
        key: "gradedAt", header: "Em Processo de Lacre", width: 120, filter: "list",
        accessor: (row) => Boolean(row.gradedAt), labels: YES_NO, format: (value) => (value ? "✔" : "X"),
        cellClassName: (row) => (row.gradedAt ? "text-green-500" : "text-red-500"),
    },
    {
        key: "ver", header: "", width: 70, sortable: false, hideable: false, exportable: false,
        cell: ({ row }) => <Link to={`/partner/products/${row._id}`} className="bg-blue-500 px-2 text-black hover:bg-blue-800">Ver</Link>,
    },
];

const PartnerProductsList = ({ products }) => (
    <SimpleTable tableKey="partner-products" columns={PARTNER_PRODUCT_COLUMNS} data={products} />
);

export default PartnerProductsList;